<template lang="pug">
    div
        //- span.title {{moment("2019-03-01", "YYYY-MM-DD")}}
        .title Monto:
        v-text-field.title#check-pay-input(
                :mask="mixCurrencyMask(checkPayment, 12)"
                placeholder="Ingrese monto del cheque"
                prefix="$"
                v-model="checkPayment"
                :rules='[rules.required, rules.validPayment, rules.notZero]'
                @keydown.enter="setFocus('ctype')"
                )
                //- @input="setPayment(checkPayment)")
        v-divider

        .title Banco:
        v-select.title(label="Seleccione tipo de cheque"
            ref="ctype"
            :items="banks"
            item-text="bank"
            item-value="id"
            v-model="bankId"
            @change="setFocus('plaza')"
            :rules='[rules.required]')
        v-divider
        
        .title Número de plaza
        v-text-field.title(solo
            placeholder="Ingrese n° de plaza"
            ref="plaza"
            v-model="plaza"
            @keydown.enter="setFocus('account')"
            :rules='[rules.required]' validate-on-blur
            mask="#######")
        v-divider
        
        .title Número de cuenta
        v-text-field.title(solo
            ref="account"
            placeholder="Ingrese n° cuenta"
            v-model="accountNumber"
            :rules='[rules.required]' validate-on-blur
            @keydown.enter="setFocus('serial')"
            mask="##################")
        v-divider

        .title Número serial cheque
        v-text-field.title(solo
            ref="serial"
            @keydown.enter="setFocus('type2')"
            placeholder="Ingrese serial del cheque"
            v-model="serialNumber"
            :rules='[rules.required, rules.serial]' validate-on-blur
            mask="NNN-NNN-NNN")
        v-divider

        //- .title Rut emisor:
        //- rut-input.title(@input="updateRut" @valid="updateValidRut")
        //- v-divider

        //- .title Nombre emisor:
        //- v-text-field.title(solo
        //-     placeholder="Ingrese nombre completo del emisor"
        //-     v-model="name"
        //-     :rules='[rules.required]' validate-on-blur)
        //- v-divider

        //- .title Fecha emisión:
        //- v-text-field.title(slot='activator' v-model='releaseDate' prepend-icon='event' disabled)
        //- v-divider

        .title Tipo de cheque
        v-select.title(label="Seleccione tipo de cheque"
            ref="type2"
            :items="checkTypesList"
            item-text="text"
            item-value="id"
            v-model="checkType"
            :rules='[rules.required]')
        v-divider

        div(v-if="checkType===1")
            .title Fecha para cobrar:
            v-menu.title(ref='chargeMenu' :close-on-content-click='false' v-model='chargeMenu' :nudge-right='40' lazy transition='scale-transition' offset-y full-width max-width='290px' min-width='290px')
                v-text-field.title(slot='activator' v-model='chargeDate' label='Seleccione fecha para cobrar' prepend-icon='event')
                v-date-picker.title(v-model='chargeDate' no-title @input='chargeMenu = false'
                                :allowed-dates="allowedDates")
        v-divider
</template>

<script>
// Components:
import RUTInput from '@/components/RUTInput/RUTInput'

// Mixins:
import PaymentRules from '@/mixins/PaymentRulesCustomerPayment'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import DateUtils from '@/mixins/DateUtils'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'check-payment',
    props: {},
    data: function() {
        return {
            // bankList: [ {id: 1, bank: 'Banco de Chile'},
            //             {id: 2, bank: 'BBVA'}],
            bankId: '',

            accountNumber: '',
            plaza: '',
            checkTypeId: '',

            checkTypesList: [
                { text: 'Cheque a fecha', id: 1 },
                { text: 'Cheque al día', id: 2 },
            ],
            checkType: '', // Cheque a fecha (1) o Cheque al día (2)

            serialNumber: '',
            rut: '',
            validRut: false,
            name: '',

            // Data related to release date of check:
            // releaseMenu: false,
            releaseDate: new Date().toISOString().substr(0, 10),
            // dateAux: new Date(),

            // Data related to charge date of check:
            chargeMenu: false,
            chargeDate: '',
            checkPayment: '',
            rules: {
                required: value => !!value || 'Debe ingresar un valor.',
                rounded: value =>
                    parseInt(value) % 10 === 0 ||
                    'Debe ingresar un valor multiplo de 10', // For cash payment
                notZero: value =>
                    parseInt(value) != 0 || 'No puede ingresar valor 0',
                validPayment: value =>
                    value <= this.totalToPay ||
                    'Pago no puede ser mayor que el total', // In case they are not paying with cash
                serial: value =>
                    value.length === 9 || 'Debe ingresar serial completo', // Serial number check payment
                validVoucher: value =>
                    value.length == 6 || 'Debe ingresar un número de 6 dígitos', // N° voucher transbank payment
                validTransNumber: value =>
                    value.length == 12 ||
                    'Debe ingresar un número de 12 dígitos', // N° transfer in bank transfer payment
                // accountNumber: value =>
                //     value.length >= 12 || 'Debe ingresar al menos 12 dígitos', // N° transfer in bank transfer payment
            },
        }
    },
    computed: {
        ...mapState('CustomerPaymentModule', {
            total: state => state.total,
            banks: state => state.banks,
        }),

        ...mapGetters('CustomerPaymentModule', {
            totalToPay: 'totalToPay',
        }),

        allCheckDataSet() {
            let allSet =
                this.checkType != '' &&
                // this.validRut &&
                // this.name != '' &&
                ((this.chargeDate != '' && this.checkType === 1) ||
                    this.checkType === 2) &&
                this.checkPayment != '' &&
                this.checkPayment <= this.totalToPay &&
                this.serialNumber.length === 9 &&
                parseInt(this.serialNumber) !== 0 &&
                this.bankId != '' &&
                this.accountNumber.length > 0 &&
                parseInt(this.accountNumber) !== 0 &&
                this.plaza != ''
            // if (allSet) {
            //     this.setPayment(this.checkPayment)
            //     let lengthRut = this.rut.length
            //     let rutAux =
            //         this.rut.slice(0, lengthRut - 1) +
            //         '-' +
            //         this.rut.slice(lengthRut - 1)
            //     let payload = {
            //         // checkTypeId: this.checkType,
            //         // rut: rutAux,
            //         // name: this.name,
            //         // releaseDate: new Date(),
            //         // chargeDate: this.chargeDate,
            //         // serialNumber: this.serialNumber,
            //         g_bank_id : this.bankId,
            //         account_number : this.accountNumber,
            //         plaza : this.plaza,
            //         pos_payment_check_type_id: this.checkType,
            //         charge_date: this.chargeDate,
            //         serial_number: this.serialNumber,
            //     }
            //     this.setPayment(this.checkPayment)
            //     this.setPaymentDetail(payload)
            // } else {
            //     this.setPayment('')
            //     this.setPaymentDetail(null)
            // }
            return allSet
        },
    },
    methods: {
        allowedDates: function(val) {
            let futureDate = new Date()
            futureDate = new Date(
                futureDate.setTime(futureDate.getTime() + 120 * 86400000)
            )
            return (
                val > this.releaseDate &&
                val <= futureDate.toISOString().substr(0, 10)
            )
        },
        ...mapActions('CustomerPaymentModule', {
            setPayment: 'setPayment',
            setPaymentDetail: 'setPaymentDetail',
            setBanks: 'setBanks',
        }),
        updateRut: function(newVal) {
            this.rut = newVal
        },

        updateValidRut: function(newVal) {
            this.validRut = newVal
        },

        setCheckPayment: function() {
            if (parseInt(this.checkPayment) === 0) {
                this.setPayment('')
            } else {
                this.setPayment(this.checkPayment)
            }
        },
        prependZeros(num, length) {
            num = '' + num
            let l = num.length
            let diff = length - l
            if (diff > 0) {
                for (let i = 0; i < diff; i++) {
                    num = '0' + num
                }
            }
            return num
        },
        checkAccountNumber() {
            if (this.accountNumber.length < 12) {
                this.accountNumber = this.prependZeros(this.accountNumber, 12)
            }
        },
        setFocus(str) {
            console.log(this.$refs[str])
            setTimeout(() => this.$refs[str].focus(), 200)
        },
    },
    watch: {
        /**
         * @description
         */
        allCheckDataSet: function(newVal, oldVal) {
            if (newVal) {
                this.setPayment(this.checkPayment)
                let lengthRut = this.rut.length
                let rutAux =
                    this.rut.slice(0, lengthRut - 1) +
                    '-' +
                    this.rut.slice(lengthRut - 1)
                let payload = {
                    // checkTypeId: this.checkType,
                    // rut: rutAux,
                    // name: this.name,
                    // releaseDate: new Date(),
                    // chargeDate: this.chargeDate,
                    // serialNumber: this.serialNumber,
                    bankId: this.bankId,
                    accountNumber: this.accountNumber,
                    plaza: this.plaza,
                    checkTypeId: this.checkType,
                    chargeDate: this.chargeDate,
                    serialNumber: this.serialNumber,
                }
                this.setPaymentDetail(payload)
            } else {
                this.setPayment('')
                this.setPaymentDetail(null)
            }
        },
    },
    components: { 'rut-input': RUTInput },
    mixins: [PaymentRules, CurrencyUtils, DateUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){},
    // beforeMount: function(){...},
    mounted: async function() {
        this.checkPayment = this.totalToPay.toString()
        this.setCheckPayment()
        await this.setBanks()
        this.$nextTick(() => document.getElementById('check-pay-input').focus())
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.title {
    margin: 10px;
}
</style>
